


import Raven from "raven-js";
import { t } from "../helpers/localization";
import WscpService from "../services";


export type SET_CLAN_TAG_TYPE = "SET_CLAN_TAG";
export const SET_CLAN_TAG: SET_CLAN_TAG_TYPE = 'SET_CLAN_TAG';

export type SET_CLAN_NAME_TYPE = "SET_CLAN_NAME";
export const SET_CLAN_NAME: SET_CLAN_NAME_TYPE = 'SET_CLAN_NAME';

export type SET_CLAN_TAG_ERROR_TYPE = "SET_CLAN_TAG_ERROR";
export const SET_CLAN_TAG_ERROR: SET_CLAN_TAG_ERROR_TYPE = 'SET_CLAN_TAG_ERROR';

export type SET_CLAN_NAME_TAG_VALIDATION_TYPE = "SET_CLAN_NAME_TAG_VALIDATION";
export const SET_CLAN_NAME_TAG_VALIDATION: SET_CLAN_NAME_TAG_VALIDATION_TYPE = 'SET_CLAN_NAME_TAG_VALIDATION';

export type SET_CLAN_NAME_PROGRESS_TYPE = "SET_CLAN_NAME_PROGRESS";
export const SET_CLAN_NAME_PROGRESS: SET_CLAN_NAME_PROGRESS_TYPE = 'SET_CLAN_NAME_PROGRESS';

export type SET_CLAN_TAG_PROGRESS_TYPE = "SET_CLAN_TAG_PROGRESS";
export const SET_CLAN_TAG_PROGRESS: SET_CLAN_TAG_PROGRESS_TYPE = 'SET_CLAN_TAG_PROGRESS';

export type CREATE_CLAN_TYPE = "CREATE_CLAN";
export const CREATE_CLAN: CREATE_CLAN_TYPE = 'CREATE_CLAN';

export type SHOW_CLAN_RULES_DIALOG_TYPE = "SHOW_CLAN_RULES_DIALOG";
export const SHOW_CLAN_RULES_DIALOG: SHOW_CLAN_RULES_DIALOG_TYPE = 'SHOW_CLAN_RULES_DIALOG';

export type HIDE_CLAN_RULES_DIALOG_TYPE = "HIDE_CLAN_RULES_DIALOG";
export const HIDE_CLAN_RULES_DIALOG: HIDE_CLAN_RULES_DIALOG_TYPE = 'HIDE_CLAN_RULES_DIALOG';

export const SetClanNameProgress = (inPropgress: boolean) => {
  return {
    type: SET_CLAN_NAME_PROGRESS,
    payload: {
      inProgress: inPropgress
    }
  };
};

export const SetClanTagProgress = (inPropgress: boolean) => {
  return {
    type: SET_CLAN_TAG_PROGRESS,
    payload: {
      inProgress: inPropgress
    }
  };
};

export const SetClanNameTagValidation = (data: any) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SET_CLAN_NAME_TAG_VALIDATION,
    payload: {
      data: data
    }
  });
};

export const SetClanTag = (value: string, error: string | null) => (dispatch: Dispatch, getState: GetState) => {

  dispatch({
    type: SET_CLAN_TAG,
    payload: {
      tag: value,
      error: error
    }
  });
  if (!error) {
    dispatch(SetClanTagProgress(true));
    WscpService.checkNameTagAvailability({ tag: value }).then(r => {
      if (r && r.current && r.current.tag) {
        if (!r.current.tag.available) {
          dispatch({
            type: SET_CLAN_TAG,
            payload: {
              tag: value,
              error: r.current.tag.reason ? t(r.current.tag.reason) : t('Клан с таким тегом уже зарегистрирован.')
            }
          });
        } else {
          dispatch({
            type: SET_CLAN_TAG,
            payload: {
              tag: value,
              error: null
            }
          });
        }
      } else {}
      dispatch(SetClanTagProgress(false));
    }).catch(err => {});
  }

};

export const SetClanName = (value: string, error: string | null) => (dispatch: Dispatch, getState: GetState) => {

  dispatch({
    type: SET_CLAN_NAME,
    payload: {
      name: value,
      error: error
    }
  });

  if (!error) {
    dispatch(SetClanNameProgress(true));
    WscpService.checkNameTagAvailability({ name: value }).then(r => {
      if (r && r.current && r.current.name) {
        if (!r.current.name.available) {
          dispatch({
            type: SET_CLAN_NAME,
            payload: {
              name: value,
              error: r.current.name.reason ? t(r.current.name.reason) : t('Клан с таким названием уже зарегистрирован')
            }
          });
        } else {
          dispatch({
            type: SET_CLAN_NAME,
            payload: {
              name: value,
              error: null
            }
          });
        }
      } else {}
      dispatch(SetClanNameProgress(false));
    }).catch(err => {});
  }
};


export const CreateClan = () => (dispatch: Dispatch, getState: GetState) => {

  const state = getState();

  if (state.Create.isProcessing) {
    const msg = 'Clan in creation process';
    console.error(msg);
    if (state.App.settings.settings.sentryUrl) {
      Raven.captureMessage(msg, { extra: state.Create });
    }
    return;
  }

  const {
    clanTag,
    clanName
  } = state.Create;

  if (!clanTag || clanTag === '' || !clanName || clanName === '') {
    console.error('Tag or name is not available');
    return;
  }

  const url = state.App.settings.urls.clanCreate; //****** */


  dispatch({
    type: CREATE_CLAN,
    payload: {}
  });
};


export const ShowClanRulesDialog = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SHOW_CLAN_RULES_DIALOG,
    payload: {}
  });
};


export const HideClanRulesDialog = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: HIDE_CLAN_RULES_DIALOG,
    payload: {}
  });
};